<template>
  <card id="notifications" :title="$t('notifications:title')" no-body no-footer>
    <div slot="card-header-right" class="d-flex">
      <input id="filterNotifications" v-model="filter" :placeholder="$t('notifications:filter') | capitalize" type="text" class="form-control form-control-sm mr-2">
      <button id="clearAllButton" class="btn btn-light btn-sm" @click="clearAll">{{ $t('notifications:clearAll') | capitalize }}</button>
    </div>

    <ul v-if="notifications.length>0" slot="card-table" class="list-group list-group-flush">
      <li v-for="notif in filteredNotifications" :key="notif.date" :class="'text-' + notif.type" class="list-group-item">
        <div class="d-flex justify-content-between align-items-center">
          <span :title="notif.message">{{ notif.message | capitalize }}</span>
          <small class="text-muted">{{ notif.date | date('hour') }}</small>
        </div>
        <div v-if="notif.details && notif.details.url" class="text-muted">
          <small><span class="text-uppercase notification-method">{{ notif.details.method }}</span>{{ shortenUrl(notif.details.url) }}</small>
        </div>
      </li>
    </ul>

    <ul v-else slot="card-table" class="list-group list-group-flush">
      <li class="list-group-item text-center text-muted font-italic">{{ $t('notifications:noData') | capitalize }}</li>
    </ul>
  </card>
</template>

<script>
import { filter, orderBy, uniq } from 'lodash-es'
import { mapGetters } from 'vuex'
import constants from '@/configuration/constants'

export default {
  titleKey: 'notifications',

  data () {
    return {
      filter: ''
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['notifications']),

    // Filter and order by newer first
    filteredNotifications () {
      const typeFiltered = filter(
        this.notifications,
        notification => notification.type.toLowerCase().indexOf(this.filter.toLowerCase()) > -1)
      const methodFiltered = filter(
        this.notifications,
        notification => notification.details && notification.details.method ? notification.details.method.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 : false)
      const urlFiltered = filter(
        this.notifications,
        notification => notification.details && notification.details.url ? this.shortenUrl(notification.details.url).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 : false)
      const messageFiltered = filter(
        this.notifications,
        notification => notification.message.toLowerCase().indexOf(this.filter.toLowerCase()) > -1)

      return orderBy(uniq([...typeFiltered, ...methodFiltered, ...urlFiltered, ...messageFiltered]), 'date', 'desc')
    }
  },

  methods: {
    shortenUrl (url) {
      if (url) {
        const noBaseUrl = url.split(constants.gmsUrl)[1]
        const noParams = noBaseUrl ? noBaseUrl.split('?')[0] : ''
        return noParams
      }
    },

    clearAll () {
      this.$store.commit('clearAllNotifications')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .text-error {
    color: $danger;
  }

  .notification-method {
    display: inline-block;
    width: 50px;
  }
</style>
